import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./ConnectedBanks.css";
import { axiosInstance } from "../../helper/axiosInstance";
import { useLanguage } from "../../LanguageContext";
import { staticUrl } from "../../config";

function ConnectedBanks() {
    const { language, textContent } = useLanguage();
    const [banks, setBanks] = useState([]);

    useEffect(() => {
        const lang = language === "ARM" ? "hy" : language === "ENG" ? "en" : "ru";
        axiosInstance.get("/connected-banks/lang?lang=" + lang).then((response) =>
            setBanks(response.data)
        );
    }, [language]);

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    return (
        <div id="connected-banks" className="connected-banks">
            <div className="connected-banks-header">
                <span style={dynamicStyles}>{textContent[language].connectedBanksHeader}</span>
                <div className="connected-banks-header_icons">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.0164407 3.82196L0 12L3.99046 12L3.99046 3.99715C4.00629 3.99715 4.9794 4.00325 4.9794 4.0002L12 4.0002L12 -5.24537e-07L3.83761 -1.67747e-07C1.73064 -7.56487e-08 0.0219223 1.70984 0.0176598 3.82196"
                            fill="#243BE2"
                        />
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.17804 11.9836L0 12L0 8.00954L8.00285 8.00954C8.00285 7.99371 7.99675 7.0206 7.9998 7.0206L7.9998 0H12L12 8.16239C12 10.2694 10.2902 11.9781 8.17804 11.9823"
                            fill="#ADF233"
                        />
                    </svg>
                </div>
            </div>
            <div className="connected-banks-title">
                <h1 style={dynamicStyles}>{textContent[language].connectedBanksTitle}</h1>
            </div>
            <div className="connected-banks-pagination_container"></div>
            <div className="connected-banks-slider">
                <Swiper
                    breakpoints={{
                        1200: {
                            spaceBetween: 20,
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        },
                        576: {
                            spaceBetween: 10,
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        },
                    }}
                    spaceBetween={25}
                    slidesPerView={6}
                    slidesPerGroup={6}
                    pagination={{
                        clickable: true,
                        el: ".connected-banks-pagination_container",
                    }}
                    modules={[Pagination]}
                >
                    {banks.map((bank, index) => (
                        <SwiperSlide key={index}>
                            <div className="connected-bank-group">
                                <div className="connected-bank-card">
                                    <div className="connected-bank-card_img">
                                        <img src={staticUrl(bank.image)} alt={`${bank.name} logo`} />
                                    </div>
                                    <div className="connected-bank-card_desc">
                                        <h3 style={dynamicStyles}>{bank.name}</h3>
                                        <p style={dynamicStyles}>{bank.description}</p>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {/* Custom Navigation Buttons */}
            <div className="connected-banks-navigation">
                <div className="connected-banks-control">
                    <button className="connected-banks-prev">
                        <div className="svg-wrapper">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17L1 9M1 9L9 1M1 9L17 9" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="svg-wrapper">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17L1 9M1 9L9 1M1 9L17 9" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </button>
                    <button className="connected-banks-next">
                        <div className="svg-wrapper">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17L17 9M17 9L9 1M17 9L1 9" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div className="svg-wrapper">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17L17 9M17 9L9 1M17 9L1 9" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
            <div className="connected-banks-slider_mobile">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={1.3}
                    navigation={{
                        prevEl: ".connected-banks-prev",
                        nextEl: ".connected-banks-next",
                    }}
                    loop={true}
                    modules={[Navigation]}
                    className="mySwiperConnectedBanks"
                >
                    {banks.map((bank, index) => (
                        <SwiperSlide key={index}>
                            <div className="connected-bank-group">
                                <div className="connected-bank-card">
                                    <div className="connected-bank-card_img">
                                        <img src={staticUrl(bank.image)} alt={`${bank.name} logo`} />
                                    </div>
                                    <div className="connected-bank-card_desc">
                                        <h3 style={dynamicStyles}>{bank.name}</h3>
                                        <p style={dynamicStyles}>{bank.description}</p>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default ConnectedBanks;
